var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75766 3.75766C5.99198 3.52335 5.99198 3.14345 5.75766 2.90913C5.52335 2.67482 5.14345 2.67482 4.90913 2.90913L2.90929 4.90898C2.90924 4.90903 2.90919 4.90908 2.90913 4.90913C2.80056 5.01771 2.7334 5.16771 2.7334 5.3334C2.7334 5.41475 2.74959 5.49232 2.77893 5.56307C2.80821 5.63384 2.85161 5.70014 2.90913 5.75766L4.90913 7.75766C5.14345 7.99198 5.52335 7.99198 5.75766 7.75766C5.99198 7.52335 5.99198 7.14345 5.75766 6.90913L4.78193 5.9334H9.3334C11.2616 5.9334 12.7334 7.35419 12.7334 9.00007C12.7334 10.6459 11.2616 12.0667 9.3334 12.0667H4.00007C3.66869 12.0667 3.40007 12.3354 3.40007 12.6667C3.40007 12.9981 3.66869 13.2667 4.00007 13.2667H9.3334C11.8239 13.2667 13.9334 11.4049 13.9334 9.00007C13.9334 6.59527 11.8239 4.7334 9.3334 4.7334H4.78193L5.75766 3.75766Z",
    fill: "#656461"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundTransaction);
export default __webpack_public_path__ + "static/media/refund-transaction.acb463212688be5beff167f45723c65f.svg";
export { ForwardRef as ReactComponent };